<template>
  <div class="summary">
    <div class="header">
      <h3 class="title"><img src="/static/images/icons/reg_alerts_full_icon.svg" class="reg_watch_icon" />
        <span>Summary</span>
      </h3>
    </div>
    <div class="row summary_row">
      <div class="col-xs-12">
        <span class="summary_heading">New updates</span>
        <span class="summary_heading_count">{{regWatchUpdates.new}}</span>
      </div>
    </div>
    <div class="row summary_row">
      <div class="col-xs-12">
        <span class="summary_heading">All updates</span>
        <span class="summary_heading_count" v-if="regWatchUpdates.view_all">{{regWatchUpdates.view_all - regWatchUpdates.archived}}</span>
      </div>
    </div>
    <div class="row summary_row">
      <div class="col-xs-12">
        <span class="summary_heading">Archive updates</span>
        <span class="summary_heading_count" v-if="regWatchUpdates.view_all">{{regWatchUpdates.archived}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getRegWatchDashboardCount } from '../../../../apis/regulatoryUpdate';

export default {
  props: ['name'],
  data() {
    return {
      regWatchUpdates: {},
    };
  },
  created() {
    this.getRegWatchDashboardCount();
  },
  methods: {
    async getRegWatchDashboardCount() {
      this.regWatchUpdates = await getRegWatchDashboardCount();
    },
  },
};
</script>
<style scoped>
.header {
  border: 1px solid #ffffff;
  border-radius: 10px 10px 0px 0px;
}
.header h3 {
  margin-top: 24px;
}
.title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
  padding-left: 24px;
}
.title span {
  padding-left: 19px;
}
.reg_watch_icon {
  width: 32px;
  height: 32px;
}
.MT-25 {
  margin-top: 25px;
}
.summary_row {
  padding: 8px 10px 0px;
}
.summary_registration,
.summary_devices {
  margin-top: 9px;
}
.summary_country {
  margin-top: 2px;
}
.summary_heading,
.summary_heading_count {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 37px;
  color: #0b3c61;
}
.summary_heading {
  margin-left: 17px;
}
.summary_heading_count {
  padding-right: 14px;
  float: right;
}
.pd-tp-0{
  padding-top: 0px !important;
}
.border_dot {
  padding-left: 0px;
}
.border_dot .border_cls {
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background: #174c76;
  margin-top: 6px;
}
.border_line .border_cls {
  margin-top: 8px;
  position: relative;
  padding: 0;
  border-top: 1px solid #174c76;
}
.border_line {
  padding-right: 0px;
}
/* @media only screen and (min-width: 1821px) {
  .summary_heading_count {
    padding-right: 30px;
  }
} */
@media only screen and (min-width: 1200px) {
  .ml-10 {
    margin-left: 10px;
  }
}
</style>
